const riot = require('riot');

riot.tag2('atom-required', '<span class="inline-block text-label_disabled bg-separator_opaque px4 py2 fs10 bold rounded-4" if="{!opts.required}">任意</span>', '', '', function(opts) {
});